document.addEventListener('DOMContentLoaded', function() {

    // Check if the section exists before running anything
    const serviceMap = document.querySelector('.service-map');
    if (!serviceMap) return;

    const filterSelect = document.getElementById('service-map-filter');
    const serviceItems = document.querySelectorAll('.service-map__services-item');
    const svg = document.querySelector('.service-map__map-inner svg');
    const zoomOutBtn = document.querySelector('.service-map__zoom-out');

    if (!svg) return; // safety check

    const svgPaths = svg.querySelectorAll('path');

    // Store initial viewBox
    const initialViewBox = svg.getAttribute('viewBox') || `0 0 ${svg.clientWidth} ${svg.clientHeight}`;

    function filterServices(selected) {
        serviceItems.forEach(section => {
            const listItems = section.querySelectorAll('ul li');
            let hasVisible = false;

            listItems.forEach(item => {
                const itemLocations = item.dataset.locations
                    ? item.dataset.locations.split(',').map(id => id.trim())
                    : [];

                if (!selected || itemLocations.includes(selected)) {
                    item.style.display = '';
                    hasVisible = true;
                } else {
                    item.style.display = 'none';
                }
            });

            section.style.display = hasVisible ? '' : 'none';
        });

        // Highlight paths and get bounding box
        let activePaths = [];
        svgPaths.forEach(path => {
            const pathLocations = path.dataset.location
                ? path.dataset.location.split(',').map(id => id.trim())
                : [];

            if (selected && pathLocations.includes(selected)) {
                path.classList.add('active');
                activePaths.push(path);
            } else {
                path.classList.remove('active');
            }
        });

        zoomToPaths(activePaths);
    }

    function zoomToPaths(paths) {
        let targetViewBox;

        // Show/hide zoom out button based on zoom state
        if (zoomOutBtn) {
            zoomOutBtn.style.display = paths.length ? 'block' : 'none';
        }

        if (!paths.length) {
            targetViewBox = initialViewBox.split(' ').map(Number);
        } else {
            let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

            paths.forEach(path => {
                const bbox = path.getBBox();
                minX = Math.min(minX, bbox.x);
                minY = Math.min(minY, bbox.y);
                maxX = Math.max(maxX, bbox.x + bbox.width);
                maxY = Math.max(maxY, bbox.y + bbox.height);
            });

            const padding = 20;
            targetViewBox = [
                minX - padding,
                minY - padding,
                (maxX - minX) + padding * 2,
                (maxY - minY) + padding * 2
            ];
        }

        const currentViewBox = (svg.getAttribute('viewBox') || initialViewBox)
            .split(' ')
            .map(Number);

        const start = { x: currentViewBox[0], y: currentViewBox[1], width: currentViewBox[2], height: currentViewBox[3] };
        const [tx, ty, tw, th] = targetViewBox;

        const duration = 500;
        const startTime = performance.now();

        function animate(time) {
            const t = Math.min((time - startTime) / duration, 1);
            const ease = t < 0.5 ? 2*t*t : -1 + (4 - 2*t)*t;

            const x = start.x + (tx - start.x) * ease;
            const y = start.y + (ty - start.y) * ease;
            const width = start.width + (tw - start.width) * ease;
            const height = start.height + (th - start.height) * ease;

            svg.setAttribute('viewBox', `${x} ${y} ${width} ${height}`);

            if (t < 1) requestAnimationFrame(animate);
        }

        requestAnimationFrame(animate);
    }

    if (filterSelect) {
        filterSelect.addEventListener('change', function() {
            filterServices(this.value.trim());
        });
    }

    if (zoomOutBtn) {
        zoomOutBtn.addEventListener('click', function() {
            if (filterSelect) filterSelect.value = '';
            filterServices('');
        });
    }

    svgPaths.forEach(path => {
        path.addEventListener('click', function() {
            // Use first location ID if multiple are specified
            const locationData = this.dataset.location || '';
            const locationId = locationData.split(',')[0].trim();
            if (filterSelect) filterSelect.value = locationId;
            filterServices(locationId);
        });
    });
});